import {v4 as uuidv4} from 'uuid';
import SingleCalculationComponentGrader = App.Entities.Tasks.ComponentGraders.SingleCalculationComponentGrader;
import CalculationBlock = App.Entities.Tasks.Ui.CalculationBlock;
import {calculationFactory} from '../../util/calculation';
import {BlockType} from '../block';

export const singleCalculation: BlockType<CalculationBlock, SingleCalculationComponentGrader> = {
  translationKey: 'calculation',
  icon: 'calculator',
  getName: (block) => block.question,
  sharedValues: ['answer'],
  providesAiContext: true,
  uiConfigFactory: () => ({
    uuid: uuidv4(),
    type: 'SingleCalculation',
    name: 'Single Calculation',
    question: '',
    appendText: null,
    prependText: null,
    part: null,
  }),
  componentGraderFactory: (uuid) => ({
    uuid: uuidv4(),
    type: 'SingleCalculation',
    name: 'Single Calculation Grader',
    uiComponentUuid: uuid,
    fallbackFeedback: '',
    calculations: [calculationFactory()],
    tolerance: {
      type: 'relative',
      value: '0.02',
    },
    subexpressions: [],
  }),
};
